import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hour4u-admin-test-call-agent',
  templateUrl: './test-call-agent.component.html',
  styleUrls: ['./test-call-agent.component.scss']
})
export class TestCallAgentComponent implements OnInit {
  phone_number: any = null;
  isWeb: boolean = false;
  submitted: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  startConversation() {

  }

  startCall() {
    this.submitted = true;
    if (!this.phone_number || this.phone_number.length != 10) {
      return;
    } else {

    }
  }
}
